import { useWorkspaceStore } from "@/stores/workspace.store.js";

export const commonGetters = {
  workspace_id: () => {
    return useWorkspaceStore().getWorkspaceID
  }
}

